module.exports = __webpack_public_path__ + "static/media/cherry-full.774723fc.png";